module.exports = __webpack_public_path__ + "img/en.549a60b4.png";